import { PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { getDynamicComponents } from 'components';
import { msalConfig } from 'utils/login/authConfig';
import ErrorBoundary from 'components/esadir/ErrorBoundary';
import ServicesProvider from 'context/ServicesProvider';
import UserProvider from 'context/UserProvider';
import ViewportProvider from 'context/corporatiu/ViewportProvider';
import styles from '../../../web/styles/esadir/globals.module.scss';

const msalInstance = new PublicClientApplication(msalConfig);
const queryClient = new QueryClient();
const DynamicComponents = getDynamicComponents('esadir');

const Appesadir = ({ Component, pageProps }) => {
    return (
        <ErrorBoundary>
            <QueryClientProvider client={queryClient}>
                <MsalProvider instance={msalInstance}>
                    <ServicesProvider>
                        <UserProvider>
                            <ViewportProvider {...pageProps}>
                                <div id='__mainContent' className={styles.esadir}>
                                    <Component {...pageProps} dynamicComponents={DynamicComponents} />
                                </div>
                            </ViewportProvider>
                        </UserProvider>
                    </ServicesProvider>
                </MsalProvider>
            </QueryClientProvider>
        </ErrorBoundary>
    );
};

export default Appesadir;
